import React, { useState, useEffect } from "react";
import { Spinner } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import ConsentModal from "../../../components/PortalSelfAssessment/ConsentModal/ConsentModal";
import AssessmentSelection from "../../../components/PortalSelfAssessment/AssessmentSelection/AssessmentSelection";
import { ASSESSMENT_TYPE } from "../../../components/PortalSelfAssessment/portalAssessmentConstant";

import RatingSystem from "../../../components/PortalSelfAssessment/RatingSystem/RatingSystem";
import InteractWithAI from "../../../components/PortalSelfAssessment/InteractWithAI/InteractWithAI";
import ChatWithAI from "../../../components/PortalSelfAssessment/ChatWithAI/ChatWithAI";

import { fetchJobPortalJobNoFilter } from '../../../store/job/action';
import { validateLinkByToken } from "@workspace/common/src/store/link/action";
import { fetchPreAssessmentDataPublic, sendPreAssessmentConsentEmail } from "@workspace/job/src/store/preAssessment/action";


const JobPortalSelfAssessment = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { jobId } = useParams();

  const [isConsentModalOpen, setIsConsentModalOpen] = useState(true);
  const [isConsentGiven, setIsConsentGiven] = useState(false);
  const [assessmentType, setAssessmentType] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);

  const jobData = useSelector(
    (state) => state.JobPortalJobReducer.jobNofilter
  );

  const preAssessmentPublicData = useSelector(
    (state) => state.PreAssessmentReducer.PreAssessmentDataPublic
  );

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("q");
    if(!token){
      navigate('/jobportal');
    } 
    dispatch(validateLinkByToken({
      token,
    }, navigate, setPageLoading));

    // Get job Id
    const candidateId = queryParams.get("c");

    if (candidateId && jobId) {
      dispatch(fetchPreAssessmentDataPublic({
        jobId,
        candidateId: parseInt(candidateId),
      }));
    }
  }, [location.search, navigate, jobId]);

  if (pageLoading) {
    <div className="d-flex align-items-center justify-content-center">
      <Spinner color="primary" />
    </div>
  }

   // Fetch job details from server
   useEffect(() => {
    dispatch(fetchJobPortalJobNoFilter(jobId));
  }, [jobId]);

  const handleConsent = () => {
    setIsConsentGiven(true);
    setIsConsentModalOpen(false);

    // Directly set the assement type here
    setAssessmentType(ASSESSMENT_TYPE[1]);

    // Send consent email
    dispatch(sendPreAssessmentConsentEmail({
      id: preAssessmentPublicData?.preAssessmentId,
    }));
  };

  const handleAssessmentSelected = (type) => {
    setAssessmentType(type);
  };

  const handleAssesementCancel = () => {
    if (assessmentType?.title === ASSESSMENT_TYPE[0]?.title) {
      setAssessmentType(null);
    }
  };

  const generateAssessment = () => {
    switch (assessmentType?.title) {
      case ASSESSMENT_TYPE[0]?.title:
        return <RatingSystem onCancel={handleAssesementCancel} />;
      case ASSESSMENT_TYPE[1]?.title:
        return <InteractWithAI jobData={jobData} />;
      case ASSESSMENT_TYPE[2]?.title:
        return <ChatWithAI />;
      default:
        return null;
    }
  };

  return (
    <div>
      {isConsentGiven && assessmentType == null && (
        <AssessmentSelection
          handleAssessmentSelected={handleAssessmentSelected}
          assessmentType={assessmentType}
        />
      )}
      <ConsentModal
        isModalOpen={isConsentModalOpen}
        handleClose={() => {setIsConsentModalOpen(false)
          navigate('/job-portal/home');
        }}
        cb={handleConsent}
        preAssessmentPublicData={preAssessmentPublicData}
      />
      {assessmentType && generateAssessment()}
    </div>
  );
};

export default JobPortalSelfAssessment;
